export default __webpack_public_path__ + "static/media/Frontend.651c4f96.svg";